import React from 'react';
import useQuery from './use-query';
import {useClaimState} from '../components/claim';
import {useSettingsState} from '../components/settings';

const useClaimStateEx = () => {
    const {defaultServiceId} = useSettingsState();
    const {serviceId = defaultServiceId} = useQuery();
    const cartState = useClaimState();
    const cs = React.useMemo(
        () =>  cartState.filter(e => e.serviceId === serviceId),
        [cartState, serviceId]
    );
    return cs;
};

export default useClaimStateEx;